module.exports = __webpack_public_path__ + "img/landing_box44.8dca9174.jpg";